import { createStore } from 'zustand';
import type { JobFilters } from '@/components/job-feed/FilterRail';

export interface JobBrowserState {
  filters: JobFilters;
  railOpen: boolean;
  select: (id: number | null) => void;
  selectedId: number | null;
  setFilters: (
    updater: JobFilters | ((prev: JobFilters) => JobFilters),
  ) => void;
  setVisibleJobIds: (ids: number[]) => void;
  toggleRail: () => void;
  visibleJobIds: number[];
}

const DEFAULT_FILTERS: JobFilters = {
  minScore: 0,
  query: '',
  sources: [],
  status: 'all',
};

export const createJobBrowserStore = () =>
  createStore<JobBrowserState>()((set) => ({
    filters: DEFAULT_FILTERS,
    railOpen: true,
    select: (id) => set({ selectedId: id }),
    selectedId: null,
    setFilters: (updater) =>
      set((state) => ({
        filters:
          typeof updater === 'function' ? updater(state.filters) : updater,
      })),
    setVisibleJobIds: (ids) => set({ visibleJobIds: ids }),
    toggleRail: () => set((state) => ({ railOpen: !state.railOpen })),
    visibleJobIds: [],
  }));

export type JobBrowserStore = JobBrowserState;
export type JobBrowserStoreApi = ReturnType<typeof createJobBrowserStore>;
